import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { WaitlistProvider } from "./context/WaitlistContext";
import Landing from "./pages/Landing";
import About from "./pages/About";
import Admin from "./pages/Admin";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <WaitlistProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </WaitlistProvider>
        <Toaster position="top-center" theme="dark" richColors />
      </BrowserRouter>
    </div>
  );
}
